module.exports = __webpack_public_path__ + "static/media/product_1@3x.2776ea15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/early_access/product_1/product_1@3x.png
// module id = 67
// module chunks = 0